var map = {
	"./insta.svg": 601,
	"./insta1.svg": 602,
	"./linkedin.svg": 603,
	"./linkedin0.svg": 604,
	"./twitter.svg": 605,
	"./twitter3.svg": 606,
	"./youtube.svg": 607,
	"./youtube2.svg": 608
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 367;